import { GetApiCall, PostApiCall } from "./axiosSetup";

export const GET_ACTIVE_GAMES = '/game/get-active-games';
export const GET_CATEGORIES = '/game/get-categories';
export const GET_SUB_GATEGORIES = '/game/get-sub-categories';
export const START_GAME = '/game/start-game';
export const START_GAME_FOR_FUN = '/game/start-game-for-fun';

export const GetGames = async () => GetApiCall(GET_ACTIVE_GAMES);
export const GetCategories = async () => GetApiCall(GET_CATEGORIES);
export const GetSubCategories = async () => GetApiCall(GET_SUB_GATEGORIES);
export const StartGame = async (data) => PostApiCall(START_GAME, data);
export const StartGameForFun = async (data) => PostApiCall(START_GAME_FOR_FUN, data);

//novi endpointi za fav igrice
export const GET_FAVORITE_GAMES   = "/game/get-favorite-games";
export const ADD_FAVORITE_GAME    = "/game/add-favorite-game";
export const REMOVE_FAVORITE_GAME = "/game/remove-favorite-game";

export const GetFavoriteGames = async (username) =>
  GetApiCall(`${GET_FAVORITE_GAMES}?username=${username}`);

export const AddFavoriteGame = async (username, data) =>
  PostApiCall(`${ADD_FAVORITE_GAME}?username=${username}`, data);

export const RemoveFavoriteGame = async (username, data) =>
  DeleteApiCallFavorite(`${REMOVE_FAVORITE_GAME}?username=${username}`, data);
